import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { CAT1_LIST, cat2List, cat3List } from "../partCategories";
import StickyHead from "../StickyHead";

const won = (n) => (Number(n) || 0).toLocaleString("ko-KR");
const comma = (v) => {
  const s = String(v ?? "").replace(/[^0-9]/g, "");
  return s === "" ? "" : Number(s).toLocaleString("ko-KR");
};
const EMPTY = {
  cat1: "", cat2: "", cat3: "", part_no: "", value: "", package: "",
  location: "", vendor: "", unit_price: "", qty: "", min_qty: "", note: "",
};

export default function PartsPage() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [fCat1, setFCat1] = useState("");
  const [low, setLow] = useState(false);
  const [error, setError] = useState("");

  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  async function load() {
    setError("");
    try {
      const params = new URLSearchParams();
      if (q) params.set("q", q);
      if (fCat1) params.set("cat1", fCat1);
      if (low) params.set("low", "1");
      const qs = params.toString();
      setRows(await api.get(`/parts${qs ? `?${qs}` : ""}`));
    } catch (err) { setError(err.message); }
  }
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fCat1, low]);

  const upd = (k) => (e) => {
    const v = e.target.value;
    setForm((f) => {
      const next = { ...f, [k]: v };
      if (k === "cat1") { next.cat2 = ""; next.cat3 = ""; }
      if (k === "cat2") { next.cat3 = ""; }
      return next;
    });
  };
  const updNum = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value.replace(/[^0-9]/g, "") }));

  function startAdd() { setEditId(null); setForm(EMPTY); setError(""); setOpen(true); }
  function startEdit(p) {
    setEditId(p.id);
    setForm({
      cat1: p.cat1 || "", cat2: p.cat2 || "", cat3: p.cat3 || "",
      part_no: p.part_no || "", value: p.value || "", package: p.package || "",
      location: p.location || "", vendor: p.vendor || "",
      unit_price: p.unit_price ? String(p.unit_price) : "",
      qty: p.qty != null ? String(p.qty) : "",
      min_qty: p.min_qty ? String(p.min_qty) : "",
      note: p.note || "",
    });
    setError(""); setOpen(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  function cancel() { setOpen(false); setEditId(null); setForm(EMPTY); }

  async function save(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true); setError("");
    const payload = {
      cat1: form.cat1 || null, cat2: form.cat2 || null, cat3: form.cat3 || null,
      part_no: form.part_no || null, value: form.value || null, package: form.package || null,
      location: form.location || null, vendor: form.vendor || null,
      unit_price: Number(form.unit_price) || 0,
      qty: Number(form.qty) || 0,
      min_qty: Number(form.min_qty) || 0,
      note: form.note || null,
    };
    try {
      if (editId) await api.post(`/parts/${editId}`, payload);
      else await api.post("/parts", payload);
      cancel(); load();
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  async function adjust(p, sign) {
    const label = sign > 0 ? "입고" : "출고";
    const raw = window.prompt(`${p.part_no || p.value || "부품"} — ${label} 수량`, "1");
    if (raw == null) return;
    const n = parseInt(String(raw).replace(/[^0-9]/g, ""), 10);
    if (!n) return;
    try { await api.post(`/parts/${p.id}/adjust`, { delta: sign * n }); load(); }
    catch (err) { setError(err.message); }
  }
  async function remove(id) {
    if (!window.confirm("부품을 삭제할까요?")) return;
    try { await api.del(`/parts/${id}`); load(); } catch (err) { setError(err.message); }
  }

  const catText = (p) => [p.cat1, p.cat2, p.cat3].filter(Boolean).join(" › ") || "—";
  const totalQty = (rows || []).reduce((s, p) => s + (Number(p.qty) || 0), 0);
  const totalValue = (rows || []).reduce((s, p) => s + (Number(p.qty) || 0) * (Number(p.unit_price) || 0), 0);

  return (
    <div>
      <StickyHead>
        <div style={{ marginBottom: 12 }}>
          <Link to="/sstoa" className="sstoa-back">← 홈</Link>
        </div>
        <div className="sstoa-topbar">
          <div>
            <h1 className="sstoa-title">부품 재고</h1>
            <p className="sstoa-sub">전자부품 재고를 카테고리별로 관리합니다.</p>
          </div>
          {!open && <button className="sstoa-btn sstoa-btn--primary" onClick={startAdd}>+ 부품 등록</button>}
        </div>
      </StickyHead>

      {error && <div className="sstoa-error" style={{ marginBottom: 12 }}>{error}</div>}

      {open && (
        <form className="sstoa-panel sstoa-panel--pad" style={{ marginBottom: 14 }} onSubmit={save}>
          <div style={{ fontWeight: 700, marginBottom: 12 }}>{editId ? "부품 수정" : "부품 등록"}</div>
          <div className="sstoa-row">
            <div className="sstoa-field"><label>대분류</label>
              <select className="sstoa-select" value={form.cat1} onChange={upd("cat1")} disabled={busy}>
                <option value="">선택</option>
                {CAT1_LIST.map((c) => <option key={c} value={c}>{c}</option>)}
              </select></div>
            <div className="sstoa-field"><label>중분류</label>
              <select className="sstoa-select" value={form.cat2} onChange={upd("cat2")} disabled={busy || !form.cat1}>
                <option value="">{form.cat1 ? "선택" : "대분류 먼저"}</option>
                {cat2List(form.cat1).map((c) => <option key={c} value={c}>{c}</option>)}
              </select></div>
            <div className="sstoa-field"><label>소분류</label>
              <select className="sstoa-select" value={form.cat3} onChange={upd("cat3")} disabled={busy || cat3List(form.cat1, form.cat2).length === 0}>
                <option value="">{cat3List(form.cat1, form.cat2).length ? "선택" : "없음"}</option>
                {cat3List(form.cat1, form.cat2).map((c) => <option key={c} value={c}>{c}</option>)}
              </select></div>
          </div>
          <div className="sstoa-row" style={{ marginTop: 12 }}>
            <div className="sstoa-field"><label>품번(제조사 품번)</label><input className="sstoa-input" value={form.part_no} onChange={upd("part_no")} disabled={busy} /></div>
            <div className="sstoa-field"><label>값/사양</label><input className="sstoa-input" value={form.value} onChange={upd("value")} placeholder="예: 10kΩ 1% / 0.1µF 50V" disabled={busy} /></div>
            <div className="sstoa-field"><label>패키지</label><input className="sstoa-input" value={form.package} onChange={upd("package")} placeholder="예: 0603, SOT-23, DIP-8" disabled={busy} /></div>
          </div>
          <div className="sstoa-row" style={{ marginTop: 12 }}>
            <div className="sstoa-field"><label>재고 수량</label><input className="sstoa-input" inputMode="numeric" style={{ textAlign: "right" }} value={comma(form.qty)} onChange={updNum("qty")} disabled={busy} /></div>
            <div className="sstoa-field"><label>최소 재고</label><input className="sstoa-input" inputMode="numeric" style={{ textAlign: "right" }} value={comma(form.min_qty)} onChange={updNum("min_qty")} disabled={busy} /></div>
            <div className="sstoa-field"><label>단가</label><input className="sstoa-input" inputMode="numeric" style={{ textAlign: "right" }} value={comma(form.unit_price)} onChange={updNum("unit_price")} disabled={busy} /></div>
          </div>
          <div className="sstoa-row" style={{ marginTop: 12 }}>
            <div className="sstoa-field"><label>보관 위치</label><input className="sstoa-input" value={form.location} onChange={upd("location")} placeholder="예: A-3 서랍" disabled={busy} /></div>
            <div className="sstoa-field"><label>구매처</label><input className="sstoa-input" value={form.vendor} onChange={upd("vendor")} disabled={busy} /></div>
          </div>
          <div className="sstoa-field" style={{ marginTop: 12 }}>
            <label>비고</label><input className="sstoa-input" value={form.note} onChange={upd("note")} disabled={busy} />
          </div>
          <div className="sstoa-actions" style={{ marginTop: 14 }}>
            <button type="submit" className="sstoa-btn sstoa-btn--primary sstoa-btn--sm" disabled={busy}>{busy ? "저장 중…" : "저장"}</button>
            <button type="button" className="sstoa-btn sstoa-btn--sm" onClick={cancel}>취소</button>
          </div>
        </form>
      )}

      {/* 검색·필터 */}
      <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap", alignItems: "center" }}>
        <form onSubmit={(e) => { e.preventDefault(); load(); }} style={{ display: "flex", gap: 8 }}>
          <input className="sstoa-input" style={{ width: 220 }} placeholder="품번·값·패키지·위치 검색" value={q} onChange={(e) => setQ(e.target.value)} />
          <button className="sstoa-btn" type="submit">검색</button>
        </form>
        <select className="sstoa-select" style={{ width: 160 }} value={fCat1} onChange={(e) => setFCat1(e.target.value)}>
          <option value="">전체 분류</option>
          {CAT1_LIST.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "var(--s-fg-dim)" }}>
          <input type="checkbox" checked={low} onChange={(e) => setLow(e.target.checked)} /> 재고 부족만
        </label>
        <div style={{ marginLeft: "auto", fontSize: 12.5, color: "var(--s-fg-mute)" }}>
          품목 {rows ? rows.length : "…"} · 총수량 {won(totalQty)} · 재고금액 {won(totalValue)}원
        </div>
      </div>

      <div className="sstoa-panel">
        {rows === null ? (
          <div className="sstoa-empty">불러오는 중…</div>
        ) : rows.length === 0 ? (
          <div className="sstoa-empty">부품이 없습니다. 우측 상단에서 등록하세요.</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table className="sstoa-table">
              <thead>
                <tr>
                  <th>분류</th><th>품번</th><th>값/사양</th><th>패키지</th><th>위치</th>
                  <th className="r">단가</th><th style={{ textAlign: "center" }}>재고</th><th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((p) => {
                  const lowStock = (Number(p.qty) || 0) <= (Number(p.min_qty) || 0);
                  return (
                    <tr key={p.id} style={{ cursor: "default" }}>
                      <td style={{ whiteSpace: "nowrap", color: "var(--s-fg-dim)" }}>{catText(p)}</td>
                      <td style={{ fontWeight: 600, whiteSpace: "nowrap" }}>{p.part_no || "—"}</td>
                      <td>{p.value || "—"}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{p.package || "—"}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{p.location || "—"}</td>
                      <td className="r" style={{ whiteSpace: "nowrap" }}>{won(p.unit_price)}</td>
                      <td style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                        <button className="sstoa-btn sstoa-btn--sm" style={{ padding: "4px 8px" }} onClick={() => adjust(p, -1)} title="출고">−</button>
                        <span style={{ display: "inline-block", minWidth: 46, textAlign: "center", fontWeight: 700, color: lowStock ? "var(--s-danger)" : "inherit" }}>{won(p.qty)}</span>
                        <button className="sstoa-btn sstoa-btn--sm" style={{ padding: "4px 8px" }} onClick={() => adjust(p, +1)} title="입고">+</button>
                        {lowStock && <span className="sstoa-tag" style={{ marginLeft: 6, background: "var(--s-danger-weak)", color: "var(--s-danger)" }}>부족</span>}
                      </td>
                      <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                        <button className="sstoa-btn sstoa-btn--sm" style={{ marginRight: 6 }} onClick={() => startEdit(p)}>수정</button>
                        <button className="sstoa-btn sstoa-btn--danger sstoa-btn--sm" onClick={() => remove(p.id)}>삭제</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
